module.exports = __webpack_public_path__ + "img/authForteKoSession.29f9368d.png";